import { ReturnItem } from '../../../core';
import { SendBack } from '../sendback-model';

export function buildAutocompleteTree(raw: SendBack[]): SendBack[] {
  const config = raw || [];
  const roots: Record<string, SendBack> = {};

  function init(n: SendBack) {
    n.isRoot = !n.subCategory;
    if (typeof n.returnText === 'string' && n.returnText.charAt(0) === '[') {
      try {
        n.returnText = JSON.parse(n.returnText);
        if (Array.isArray(n.returnText)) {
          n.approvedText = n.returnText.map((n: any, i) => {
            if (n.text) {
              return n.text + ' '.repeat(i);
            }
            return n;
          });
        }
      } catch (e) {
        console.info('returnText parsing error', n.returnText);
      }
    }
    roots[n.category] = n.isRoot ? n : { ...n };
  }

  config.forEach(init);
  const rootList = Object.values(roots);

  const childs: Record<string, SendBack> = {};
  function findChildren(root: SendBack) {
    root.subReasons = config.filter((n) => n.category === root.category && n !== root);
    root.subReasons.forEach((n) => {
      childs[n.code] = n;
      n.useComments = n.code.includes('COM') || (n.description && n.description?.toLowerCase().includes('comments'));
    });
  }

  rootList.forEach(findChildren);

  let sum = 0;
  rootList.forEach((n) => (sum += n.subReasons!.length));
  // console.info('roots len', rootList.length + sum, 'conf', config.length);

  config.forEach((n) => {
    if (!roots[n.code] && !childs[n.code]) {
      console.info('child not proceessed, converting to root ?', n);
      n.isRoot = true;
      // rootList.push(n);
    }
  });

  // console.info('final len', rootList.length + sum, 'conf', config.length);

  return rootList;
}

export function buildReturnItems(selected: SendBack[], { sendToList, worksheetId }: ReturnItem): ReturnItem[] {
  const returnItems: ReturnItem[] = [];

  function setSelectedCode(s: SendBack) {
    const { code, subReasons, returnText, insertedReturnText, description, isRoot } = s;

    const selected = s.selected || (isRoot && subReasons?.length < 1);

    if (code && selected) {
      let item: Partial<ReturnItem> = { code, sendToList, worksheetId };
      if (insertedReturnText) {
        item.returnText = insertedReturnText;
      } else if (typeof returnText === 'string') {
        item.returnText = returnText;
      } else if (Array.isArray(returnText)) {
        item.returnText = returnText[0]?.text;
      } else {
        item.returnText = undefined;
      }

      let comment = item.returnText || '';
      if(comment.includes('$')){
        comment = description;
      }

      item.comment = comment;
      item.workflows = s.workflows;
      item.category = s.category;
      item.subCategory = s.subCategory;
      item.flag = s.flag;
      item.newAction = s.newAction;
      item.tags = s.tags;

      returnItems.push(item as ReturnItem);
    }
    if (subReasons) {
      subReasons.forEach((n) => setSelectedCode(n));
    }
  }
  selected.forEach((n) => setSelectedCode(n));

  return returnItems;
}

export function findSendbackByCode(code: String, list: SendBack[]) {
  function search(a: SendBack) {
    if (a.code === code) {
      return a;
    }
    if (a.subReasons) {
      return a.subReasons.find((a) => a.code === code);
    }
    return undefined;
  }
  return list.find((a) => search(a));
}


export function unselectAll(selected: SendBack[]){

  function unselect(s: SendBack){
    s.selected = false;
    if(s.subReasons){
      s.subReasons.forEach((n) => unselect(n));
    }
  }
  selected.forEach((n) => unselect(n));
}